<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Адрес местонахождения</div>
            <div class="dx-field-value">
                <ai-text-box-readonly :value="data?.kod_d" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import AiTextBoxReadonly from '@/components/ai-text-box-readonly.vue';

const data = inject('data');
</script>
